import { z } from 'zod';
import { columnSchema, modelSchema, moduleSchemaSchema, relationSchema } from './moduleSchema.js';
export const enrichedColumnSchema = columnSchema.extend({
    name: z.string(),
    forRelation: z.string().optional(),
    fakerMethod: z
        .object({
        method: z.string(),
        label: z.string(),
        description: z.string(),
        params: z.array(z.any()),
    })
        .nullable()
        .optional(),
});
export const enrichedRelationSchema = relationSchema.extend({
    name: z.string(),
    displayName: z.string(),
    model: z.string(),
});
export const enrichedModelSchema = modelSchema.extend({
    name: z.string(),
    displayName: z.string(),
    displayNamePlural: z.string(),
    columns: z.record(z.string(), enrichedColumnSchema),
    relations: z.record(z.string(), enrichedRelationSchema),
});
export const enrichedModuleSchemaSchema = moduleSchemaSchema.extend({
    name: z.string(),
    displayName: z.string(),
    icon: z.string(),
    model: enrichedModelSchema,
});
